import { render } from "./DepotTables.vue?vue&type=template&id=61b403a0&scoped=true"
import script from "./DepotTables.vue?vue&type=script&lang=js"
export * from "./DepotTables.vue?vue&type=script&lang=js"

import "./DepotTables.vue?vue&type=style&index=0&id=61b403a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b403a0"]])

export default __exports__